import urls from 'constants/urls.json';
import { getPromotionalModule } from 'modules/api';

export const PROMOTIONAL_MODULE_REQUEST = 'PROMOTIONAL_MODULE_REQUEST';
export const PROMOTIONAL_MODULE_RECEIVED = 'PROMOTIONAL_MODULE_RECEIVED';

export const requestPromotionalModule = () => {
  return { type: PROMOTIONAL_MODULE_REQUEST };
};

export const receivedPromotionalModule = (promotionalModule) => {
  return { type: PROMOTIONAL_MODULE_RECEIVED, promotionalModule };
};

export const fetchPromotionalModule = () => {
  return async (dispatch) => {
    dispatch(requestPromotionalModule());

    const promotionalModule = await getPromotionalModule(
      urls['promotional-module']
    );

    if (!promotionalModule) return dispatch(receivedPromotionalModule([]));

    dispatch(receivedPromotionalModule(promotionalModule));
  };
};
